import React from "react";
import "./TestimonialsStyle.scss";
import { testimonialsTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "../Common_UI_Kit/EmblaArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

const TestimonialsSection = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      slidesToScroll: "auto",
      align: "start",
      loop: true,
    },
    [Autoplay({ playOnInit: true, delay: 3000, stopOnInteraction: false })]
  );

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="testimonials-section">
      <div className="testimonials-wrap">
        <SectionHeading>{testimonialsTextContent.headingText}</SectionHeading>

        <div className="testimonials-box">
          <div className="embla">
            <div className="embla__viewport" ref={emblaRef}>
              <div className="embla__container">
                {testimonialsTextContent.content.map((item, index) => (
                  <div className="embla__slide" key={index}>
                    <div className="testimonial-card">
                      <div className="testimonial-profile-box">
                        <img
                          src="/assets/svg-img/testimonial-bg-img.svg"
                          alt="Image"
                          className="testimonial-bg-img"
                        />
                        <div className="profile-img-box">
                          <img src={item.profileImageSrc} alt="Image" />
                        </div>
                        <div className="profile-text-box">
                          <h5 className="name-text">{item.profileNameText}</h5>
                          <h6 className="designation-text">
                            {item.profileDesignationText}
                          </h6>
                        </div>
                        <img
                          src="/assets/svg-img/testimonial-quotes-img.svg"
                          alt="Image"
                          className="testimonial-quotes-img"
                        />
                      </div>

                      <div className="text-box">
                        <p className="para-text">{item.paraText}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="embla-buttons-box">
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
